import { render, staticRenderFns } from "./AddProductsToCategoryModal.vue?vue&type=template&id=43a4dd1a&scoped=true"
import script from "./AddProductsToCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddProductsToCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a4dd1a",
  null
  
)

export default component.exports